import { callApi } from "./api";
import { getQueryString, getOffsetLimitFromPagination } from "../utils/query";

class DiagnosesService {
  async getAllDiagnoses(searchValue) {
    return await callApi({
      url: `/api/diagnosis/?search=${searchValue}&limit=2000`,
      method: "GET",
    });
  }
}
export const diagnosesService = new DiagnosesService();
